import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';

import { Container, Text } from '@uncinc/uncinc-react-kitchen-sink';

import { Paragraph } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphAccordion as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphAccordionProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphAccordion: React.FC<ParagraphAccordionProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const uuid = paragraph.uuid[0].value;
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;

  return (
    <div id={uuid} className="ParagraphAccordion">
      <Container>
        <Text
          title={title}
          text={body || ''}
        />
        {paragraph.field_paragraphs.map((item) => (
          <Paragraph
            key={`item:${item.target_uuid}`}
            id={item.target_id}
            entity={Immutable.fromJS(item.entity)}
            className="mb-0"
          />
        ))}
      </Container>
    </div>
  );
};

export default ParagraphAccordion;
